import { FaAccessibleIcon } from 'react-icons/fa';
import { Resources } from '../../resource';
import { ResourceOptions } from 'react-admin';

export { default as list } from './List';
export const name = Resources.whitelistReward;
export const options: ResourceOptions = {
  label: 'whitelist.earlyBird.title',
};
